import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@supabase/auth-helpers-react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { AccessCodeDialog } from "./access/AccessCodeDialog";
import { AccessCodeList } from "./access/AccessCodeList";
import { AccessControlContainer } from "./access/AccessControlContainer";
import { AccessControlHeader } from "./access/AccessControlHeader";
import { FeatureAccessList } from "./security/FeatureAccessList";
import { toast } from "sonner";

export const AccessControlSettings = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState("");
  const user = useUser();

  const { data: accessCodes, refetch, isError } = useQuery({
    queryKey: ["accessCodes", user?.id],
    queryFn: async () => {
      if (!user?.id) {
        console.log("No active user found");
        return [];
      }

      console.log("Fetching access codes for user:", user.id);

      const { data, error } = await supabase
        .from("access_controls")
        .select("*")
        .eq('owner_id', user.id)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching access codes:", error);
        toast.error("Erreur lors du chargement des codes d'accès");
        throw error;
      }
      
      return data;
    },
    enabled: !!user?.id,
  });

  const handleFeatureClick = (feature: string) => {
    setSelectedFeature(feature);
    setIsDialogOpen(true);
  };

  if (isError) {
    return (
      <AccessControlContainer message="Erreur lors du chargement des codes d'accès" />
    );
  }

  return (
    <div className="space-y-6">
      <FeatureAccessList onFeatureClick={handleFeatureClick} />
      <Card>
        <AccessControlHeader onAddCode={() => setIsDialogOpen(true)} />
        <CardContent className="space-y-4">
          <AccessCodeList codes={accessCodes || []} />
          <AccessCodeDialog 
            open={isDialogOpen} 
            onOpenChange={setIsDialogOpen}
            onSuccess={() => {
              setIsDialogOpen(false);
              refetch();
            }}
            selectedFeature={selectedFeature}
          />
        </CardContent>
      </Card>
    </div>
  );
};